import { render, staticRenderFns } from "./InventoryEvents.vue?vue&type=template&id=a59c2ac6&scoped=true"
import script from "./InventoryEvents.vue?vue&type=script&lang=js"
export * from "./InventoryEvents.vue?vue&type=script&lang=js"
import style0 from "./InventoryEvents.vue?vue&type=style&index=0&id=a59c2ac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59c2ac6",
  null
  
)

export default component.exports